
export class HistoryStack<T> {
  private past: T[] = [];
  private future: T[] = [];
  private present: T;
  private maxHistory: number;

  constructor(initialState: T, maxHistory = 50) {
    this.present = initialState;
    this.maxHistory = maxHistory;
  }

  public push(newState: T) {
    // Push current state to past
    this.past.push(this.present);
    
    // Limit history size
    if (this.past.length > this.maxHistory) {
      this.past.shift();
    }
    
    // Update present
    this.present = newState;
    
    // Clear future (new branch of history)
    this.future = [];
  }

  public undo(): T | null {
    if (this.past.length === 0) return null;
    
    const previous = this.past.pop()!;
    
    this.future.push(this.present);
    this.present = previous;
    
    return this.present;
  }

  public redo(): T | null {
    if (this.future.length === 0) return null;
    
    const next = this.future.pop()!;
    
    this.past.push(this.present);
    this.present = next;
    
    return this.present;
  }

  public getCurrent(): T {
    return this.present;
  }
  
  public clear(initialState: T) {
      this.past = [];
      this.future = [];
      this.present = initialState;
  }
  
  public canUndo(): boolean {
      return this.past.length > 0;
  }
  
  public canRedo(): boolean {
      return this.future.length > 0;
  }
}
